export default {"src":"/_next/static/media/close-black.787ef406.svg","height":24,"width":24};